import React from 'react';

import { customTheme } from 'theme';

import { CheckmarkCircleIcon, Tag } from 'app/components';

const styles = {
  tag: {
    border: '1px solid',
    borderRadius: 'md',
    borderColor: customTheme.colors.gray['200'],
    bg: 'white',
    px: 4,
    py: 1.5,
    fontSize: 14,
  },
  leftIcon: {
    color: 'green.300',
    pr: 3,
  },
};

const renderTag = label => (
  <Tag
    label={label}
    leftIcon={<CheckmarkCircleIcon w={6} h={6} />}
    styles={styles}
  />
);

export const ReadOnlyTag = () => {
  return renderTag('READ-ONLY');
};

export const ReadWriteTag = () => {
  return renderTag('READ-WRITE');
};
